export default {
  getAllEmployees(state) {
    return state.employees
  }
}
